<template>
  <div :class="[b(), className]" :style="styleSizeName">
    <div :ref="id" :style="MinusDrillHeightStyle" v-show="dataChart?.length || !isDataCenter"></div>
    <noDataSvg :color="editorType === 1 ? '#787A80' : '#787A80'" v-if="!dataChart?.length && isDataCenter"/>
    <ChartNav @multiDrill="multiDrill" :currentDrillRouteIndex="currentDrillRouteIndex" @multiJump="multiJump"
              :multiActionsParam="multiActionsParam" v-model="drillIndex" :prop='prop' :option="option"
              :drillClickList="drillClickList" :drillDimList="drillDimList"></ChartNav>
  </div>
</template>

<script>
import create from "../../create";
import noDataSvg from './svg.vue'

export default create({
  name: "line",
  components: {
    noDataSvg: noDataSvg
  },
  data() {
    return {
      formatter: (params, data) => {
        // 这里兼容 trigger是item的情况
        if (!Array.isArray(params)) {
          params = [params]
        }
        if (!this.option.tipContent) {
          this.option.tipContent = ['维度值', '指标名', '指标值']
        }
        let content = '';
        if (this.option.tipContent?.includes('维度值')) {
          content += `<div>${params[0].name}</div>`
        }
        params.forEach(item => {
          content += '<div>'
          if (this.option.tipContent?.includes('指标名')) {
            content += `${item.seriesName}`
          }
          if (this.option.tipContent?.includes('指标值')) {
            if (this.option.tipContent?.includes('指标名')) {
              content += '：'
            }
            const unit = this.getUnit(item.seriesName)
            content += `${item.value}${unit}`
          }
          content += '</div>'
        })
        return content
      },
      labelFormatter: (params, data) => {
        let content = '';
        if (this.option.labelContent?.includes('维度值')) {
          content += `${params.name}`
        }
        if (this.option.labelContent?.includes('指标值')) {
          if (this.option.labelContent?.includes('维度值')) {
            content += '：'
          }
          const unit = this.getUnit(params.seriesName)
          content += `${params.value}${unit}`
        }
        return content
      }
    }
  },
  computed: {
    isView() {
      return this.$route.name === 'view'
    }
  },
  methods: {
    // 获取单位
    getUnit(name) {
      const fieldItem = this.prop?.metrics?.find(item => item.name === name || item.fieldName === name) || {}
      if (fieldItem?.set?.type === 'percent') {
        return '%'
      }
      return fieldItem?.set?.indexUnit || ''
    },
    // 分离数据，主次指标分离
    separateMetric(option) {
      const {series = [], seriesL = []} = option
      const {metrics = [], metricsL = []} = this.prop
      let separatedMetric = {
        mainMetrics: [],
        subMetrics: [],
      }
      // 兼容次指标通过类型放在指标中的逻辑
      const oldVersionMetricType = metrics.find(item => item.metricType === 'sub')
      if (oldVersionMetricType) {
        series.forEach((dataItem) => {
          const metItem = metrics.find(item => dataItem.name === item.name || dataItem.originName === item.name)
          if (metItem.metricType === 'sub') {
            separatedMetric.subMetrics.push({
              code: metItem.code,
              metricType: metItem.metricType,
              set: metItem.set,
              ...dataItem,
            })
          } else {
            separatedMetric.mainMetrics.push({
              code: metItem.code,
              metricType: metItem.metricType,
              set: metItem.set,
              ...dataItem,
            })
          }
        })
      } else {
        series.forEach((dataItem) => {
          const metItem = metrics.find(item => dataItem.name === item.name || dataItem.originName === item.name)
          separatedMetric.mainMetrics.push({
            code: metItem.code,
            set: metItem.set,
            ...dataItem,
          })
        })
        seriesL.forEach((dataItem) => {
          const metItem = metricsL.find(item => dataItem.name === item.name || dataItem.originName === item.name)
          separatedMetric.subMetrics.push({
            code: metItem.code,
            metricType: 'sub',
            set: metItem.set,
            ...dataItem,
          })
        })
      }
      return separatedMetric
    },
    // 获取次指标轴配置项，
    obtainSubYAxis(optionData) {
      const {
        fontFamily = '',
      } = this.themeCfg
      const subYAxis = {
        show: this.validData(this.option.subYAxis.yAxisShow, false),
        type: "value",
        name: this.option.subYAxis.showYAxisName ? this.option.subYAxis.yAxisName : '',
        nameTextStyle: {
          color: this.option.subYAxis.yAxisNameColor || "#fff",
          fontSize: this.option.subYAxis.yAxisNameFontSize || 14,
          fontFamily: this.option.subYAxis.yAxisNameFontFamily || fontFamily,
          padding: [0, 0, this.option.subYAxis.yAxisNameBottom || 0, this.option.subYAxis.yAxisNameLeft || 0]
        },
        min: this.option.subYAxis.yAxisMinAuto ? null : this.option.subYAxis.yAxisMin,
        max: this.option.subYAxis.yAxisMaxAuto ? null : this.option.subYAxis.yAxisMax,
        interval: this.option.subYAxis.yAxisIntervalAuto ? null : this.option.subYAxis.yAxisInterval,
        minInterval: this.option.subYAxis.yAxisminInterval,
        data: optionData.categories || [],
        axisLabel: {
          show: this.validData(this.option.subYAxis.yAxisLabelShow, true),
          rotate: this.option.subYAxis.yAxisRotate,
          textStyle: {
            color: this.option.subYAxis.yAxisColor || "#fff",
            fontSize: this.option.subYAxis.yAxisFontSize || 14,
            fontFamily: this.option.subYAxis.yAxisFontFamily || fontFamily,
          }
        },
        axisLine: {
          show: this.validData(this.option.subYAxis.yAxisLineShow, true),
          lineStyle: {
            color: this.option.subYAxis.yAxisLineColor || "#fff",
            width: this.option.subYAxis.yAxisLineWidth
          }
        },
        inverse: this.validData(this.option.subYAxis.yAxisInverse, false),
        splitLine: {
          show: this.validData(this.option.subYAxis.yAxisSplitLineShow, false),
          lineStyle: {
            type: this.option.subYAxis.yAxisSplitLineShowDotted ? [5, 8] : "solid", //设置网格线类型 dotted：虚线   solid:实线
            color: this.option.subYAxis.yAxisSplitLineColor || "#ccc",
            width: this.option.subYAxis.yAxisSplitLineWidth
          },
        }
      }
      return subYAxis
    },
    updateChart() {
      // series 基础配置
      const seriesConfig = () => {
        // 兼容旧配置
        const areaStyleFunc = () => {
          if (!this.option?.areaStyle ?? false) return
          if (this.option?.areaFollowLine) return {
            opacity: this.option?.areaOpacity ?? 0.7
          }
          const colorStops = [{
            offset: 0,
            color: this.option.areaColor[0].color1 // 0% 处的颜色
          }, {
            offset: this.option.areaColor[0].position / 100,
            color: this.option.areaColor[0].color2 // 100% 处的颜色
          }]
          return {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: colorStops,
              global: false // 缺省为 false
            },
            opacity: 0.7
          }
        }

        return {
          type: "line",
          smooth: this.validData(this.option.smooth, true),
          showSymbol: this.validData(this.option.symbolShow, false),
          symbol: this.option.symbolKind,
          symbolSize: this.option.symbolSize || 10,
          showAllSymbol: true,
          areaStyle: areaStyleFunc(),
          lineStyle: {
            width: this.option.lineWidth || 1
          },
          label: this.getOptionLabel({
            position: this.option.labelPosition
          }),
          labelLine: {
            show: this.option.labelContent?.includes('引导线') || false
          },
        }
      }

      const optionData = this.deepClone(this.dataChart);
      const option = {
        dataZoom: this.getDataZoom(),
        title: this.getOptionTitle(),
        tooltip: this.getOptionTip({
          trigger: this.isTrendChart ? 'item' : "axis",
          confine: true
        }),
        grid: this.getOptionGrid(),
        legend: this.getOptionLegend(),
        xAxis: this.getXAxisOption({
          type: "category",
          data: optionData.categories || [],
        }),
        yAxis: this.getYAxisOption({
          type: "value",
          name: this.option.showYAxisName ? this.option.yAxisName : '',
          min: this.option.yAxisMinAuto ? null : this.option.yAxisMin,
          max: this.option.yAxisMaxAuto ? null : this.option.yAxisMax,
          interval: this.option.yAxisIntervalAuto ? null : this.option.yAxisInterval,
          minInterval: this.option.yAxisminInterval,
          data: optionData.categories || [],
        }),
        series: (() => {
          const list = (optionData.series || []).map((ele, index) => {
            return {
              ...ele,
              itemStyle: this.getHasProp(!this.switchTheme, {
                color: this.getColor(index)
              }),
              ...seriesConfig()
            }
          });
          return list;
        })()
      };
      if (this.isDataCenter) {
        let _op = this.getDimentionOption()
        const separatedMetric = this.separateMetric(_op)
        const {
          mainMetrics = [],
          subMetrics = []
        } = separatedMetric
        option.yAxis.data = _op.categories
        option.xAxis.data = _op.categories
        const mainYAxisName = this.option.yAxisName || `${mainMetrics[0]?.name || ''} ${mainMetrics[0]?.set?.indexUnit || ''}`
        const subYAxisName = this.option.subYAxis?.yAxisName || `${subMetrics[0]?.name || ''} ${subMetrics[0]?.set?.indexUnit || ''}`
        const subYAxis = this.option.subYAxis ? this.obtainSubYAxis(optionData) : option.yAxis
        option.yAxis = [
          {
            ...option.yAxis,
            name: this.option.showYAxisName ? mainYAxisName : '',
          },
          {
            ...subYAxis,
            name: this.option?.subYAxis?.showYAxisName ? subYAxisName : '',
            data: _op.categories,
          }
        ]
        let _legend = [...mainMetrics, ...subMetrics]
        if (this.isTrendChart && this.prop?.trendDim?.length) {
          _legend = this.getTrendData()
        }
        option.legend = this.getOptionLegend(_legend);
        option.series = _legend.map((el, index) => {
          const basic = seriesConfig()
          let cusItemFonfig = {}
          // 指标通用配置合并个性化配置，个性化配置优先
          if (this.option?.lineCustomSet && this.option?.lineCustomSet.length) {
            const cusItem = this.option?.lineCustomSet.find(_el => {
              // 此处折线图右轴指标用的类型匹配
              if (el?.metricType === 'sub')
                return _el.metric === `metricsL--${el.code}`
              // 主指标匹配
              return _el.metric === el.code
            })
            if (cusItem) {
              cusItemFonfig = {
                smooth: cusItem?.smooth ?? (basic.smooth),
                lineStyle: {
                  width: cusItem?.lineWidth ?? (basic.lineStyle.width)
                },
                symbol: cusItem?.symbolKind ?? (basic.symbol),
                symbolSize: cusItem?.symbolSize ?? (basic.symbolSize),
                areaStyle: (() => {
                  if (cusItem?.showArea ?? false) {
                    if (basic?.areaStyle) return {
                      ...basic.areaStyle,
                      opacity: cusItem.areaOpacity
                    }

                    return {opacity: cusItem.areaOpacity}
                  }
                })()
              }
            }
          }

          return {
            ...basic,
            ...el,
            ...{
              itemStyle: this.getHasProp(!this.switchTheme, {
                color: this.getColor(index)
              }),
              yAxisIndex: el.metricType === 'sub' ? 1 : 0,
              triggerLineEvent: true,
              markLine: {
                ...this.getMarkLineDefaultSet(),
                lineStyle: {
                  width: this.option.yAxisMarkLineWidth || 1,
                  type: this.option.yAxisMarkLineType,
                  color: this.option.yAxisMarkLineColor || "#FF0000",
                },
                data: (el.metricType === 'sub' ? this.option?.subYAxis?.yAxisMarkLineShow : this.option.yAxisMarkLineShow) && this.getMarklineOption(el.metricType === 'sub' ? true : '')
              }
            },
            ...cusItemFonfig
          };
        })
        this.myChart.on('click', 'series.line', (e) => {
          const item = e
          const {
            seriesName,
            seriesIndex,
          } = item
          const curMetric = [...mainMetrics, ...subMetrics][seriesIndex] || {}
          const yAxisName = `${seriesName} ${curMetric?.set?.indexUnit || ''}`
          const curOption = this.myChart.getOption()
          if (curMetric?.metricType === 'sub') {
            curOption.yAxis.splice(1, 1, {
              ...curOption.yAxis[1],
              name: yAxisName,
            })
          } else {
            curOption.yAxis.splice(0, 1, {
              ...curOption.yAxis[0],
              name: yAxisName,
            })
          }
          this.myChart.setOption(this.echartsOptionHandler(curOption), true);
        })
      }
      this.myChart.resize();
      this.myChart.setOption(this.echartsOptionHandler(option), true);
    }
  }
});

</script>
